<section class="centered-with-padding pb-14 pt-7">
  <div class="grid grid-cols-1 gap-3 desk:grid-cols-2">
    @for (filterPage of filterPages(); track filterPage.url) {
      <div class="h-[274px] desk:h-[400px]">
        <a [routerLink]="filterPage.url">
          <app-option-card [image]="filterPage.image">
            <div card-title-left>{{ filterPage.title }}</div>
            <div class="w-[17px]" card-title-right>
              <app-svg [height]="13" [width]="17" src="assets/icons/arrow-right.svg" />
            </div>
          </app-option-card>
        </a>
      </div>
    }
  </div>
</section>
